import SelectJingdongModal from './SelectJingdongModal'
export default SelectJingdongModal